import React from 'react';
import { Button } from '../components/ui/button';
import { ChevronRight, ArrowRight } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const HeroSection = ({ scrollY, onNavigate }) => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="hero-background absolute inset-0 z-0"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`,
          backgroundImage: `linear-gradient(rgba(11, 158, 217, 0.85), rgba(30, 95, 138, 0.90)), url(${IMAGES.hero})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="hero-overlay absolute inset-0 z-1" />
      
      <div className="hero-content relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <div className="logo-container mb-8 flex justify-center">
          <img src={IMAGES.logo} alt="SolidCloud Logo" className="h-32 sm:h-40 w-auto hero-logo" />
        </div>
        
        <h1 className="hero-headline text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Redefining Lightweight Performance Materials for the Next Industrial Era
        </h1>
        
        <p className="hero-subheadline text-lg sm:text-xl md:text-2xl text-cream-100 mb-12 max-w-4xl mx-auto">
          Advanced aerogel solutions engineered for thermal protection, energy systems, and high-performance industrial applications.
        </p>
        
        <div className="hero-cta-buttons flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button size="lg" className="cta-primary" onClick={() => onNavigate('technology')}>
            Explore Technology <ChevronRight className="ml-2 h-5 w-5" />
          </Button>
          <Button size="lg" variant="outline" className="cta-secondary" onClick={() => onNavigate('applications')}>
            Industry Applications <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      <button 
        onClick={scrollToAbout}
        className="scroll-indicator absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 cursor-pointer bg-transparent border-none p-4 hover:scale-110 transition-transform duration-300"
        aria-label="Scroll to Who We Are section"
      >
        <div className="scroll-arrow" />
      </button>
    </section>
  );
};

export default HeroSection;

